const CART_PRODUCT_INCREMENT_SECTION = 'cart-product-increment';

function getRoutesRoot() {
  if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
    return window.Shopify.routes.root;
  }
  return '/';
}

function getRelatedProductLabels(container) {
  return {
    add: container.dataset.labelAdd || 'ADD',
    options: container.dataset.labelOptions || 'OPTIONS',
    selectOption: container.dataset.labelSelectOption || 'Select __NAME__',
    sku: container.dataset.labelSku || 'SKU',
    decrease: container.dataset.labelDecrease || 'Decrease',
    increase: container.dataset.labelIncrease || 'Increase',
    quantity: container.dataset.labelQuantity || 'Quantity',
    variant: container.dataset.labelVariant || 'Variant',
  };
}

function formatSelectOptionLabel(template, name) {
  return (template || 'Select __NAME__').replace('__NAME__', name);
}

function formatRelatedMoney(cents) {
  if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
    return Shopify.formatMoney(cents, Shopify.money_format || '${{amount}}');
  }

  const locale =
    (typeof Shopify !== 'undefined' && Shopify.locale) ||
    document.documentElement.lang ||
    'en-CA';
  const currency =
    (typeof Shopify !== 'undefined' && Shopify.currency && Shopify.currency.active) || 'CAD';

  return (cents / 100).toLocaleString(locale, {
    style: 'currency',
    currency,
  });
}

function parseQtyIncrement(value) {
  const n = parseInt(value, 10);
  return Number.isFinite(n) && n > 0 ? n : 1;
}

function getQtyIncrementFromInput(input) {
  if (!input) return 1;
  return parseQtyIncrement(input.dataset.qtyIncrement || input.min || 1);
}

function normalizeQtyToIncrement(quantity, increment) {
  const qty = parseInt(quantity, 10);
  if (!Number.isFinite(qty) || qty <= 0) return increment;
  if (qty <= increment) return increment;
  return Math.ceil(qty / increment) * increment;
}

function fetchProductIncrement(handle) {
  if (!handle) return Promise.resolve(1);

  const root = getRoutesRoot();
  return fetch(
    `${root}products/${encodeURIComponent(handle)}?section_id=${CART_PRODUCT_INCREMENT_SECTION}`,
  )
    .then((res) => res.text())
    .then((html) => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const el = doc.querySelector('[data-cart-product-increment]');
      return parseQtyIncrement(el && el.getAttribute('data-cart-product-increment'));
    })
    .catch(() => 1);
}

function fetchProductIncrements(products) {
  const handles = [...new Set(products.map((p) => p.handle).filter(Boolean))];

  return Promise.all(
    handles.map((handle) =>
      fetchProductIncrement(handle).then((increment) => [handle, increment]),
    ),
  ).then((entries) => {
    const map = Object.fromEntries(entries);
    return products.map((product) => map[product.handle] || 1);
  });
}

function bindRelatedProductQtyControls(container) {
  container.querySelectorAll('.cart-related-product-qty-minus').forEach((btn) => {
    btn.onclick = function () {
      const row = this.closest('.cart-related-product-row');
      const input = row && row.querySelector('.cart-related-product-qty-input');
      if (!input) return;

      const increment = getQtyIncrementFromInput(input);
      const current = parseInt(input.value, 10) || increment;
      input.value = Math.max(increment, current - increment);
    };
  });

  container.querySelectorAll('.cart-related-product-qty-plus').forEach((btn) => {
    btn.onclick = function () {
      const row = this.closest('.cart-related-product-row');
      const input = row && row.querySelector('.cart-related-product-qty-input');
      if (!input) return;

      const increment = getQtyIncrementFromInput(input);
      const current = parseInt(input.value, 10) || increment;
      input.value = current + increment;
    };
  });

  container.querySelectorAll('.cart-related-product-qty-input').forEach((input) => {
    input.addEventListener('change', function (event) {
      event.stopPropagation();
      const increment = getQtyIncrementFromInput(this);
      this.value = normalizeQtyToIncrement(this.value, increment);
    });
  });
}

function renderRelatedProducts() {
  const container = document.getElementById('CartDrawerRelatedProductsSlider');
  if (!container) return;

  const labels = getRelatedProductLabels(container);
  const root = getRoutesRoot();

  fetch(`${root}cart.js`)
    .then((res) => res.json())
    .then((cart) => {
      if (!cart.items || !cart.items.length) return;

      const firstProductId = cart.items[0].product_id;

      const parsedLimit = parseInt(container.dataset.limit, 10);
      const limit = Number.isFinite(parsedLimit)
        ? Math.min(Math.max(parsedLimit, 1), 10)
        : 8;

      return fetch(
        `${root}recommendations/products.json?product_id=${firstProductId}&limit=${limit}&intent=related`,
      )
        .then((res) => res.json())
        .then((data) => {
          if (!data.products || !data.products.length) return;

          return fetchProductIncrements(data.products).then((increments) => {
            let html = '';

            data.products.forEach((product, index) => {
              const firstVariant = product.variants[0];
              const qtyIncrement = increments[index] || 1;

              const optionName =
                product.options && product.options[0]
                  ? typeof product.options[0] === 'string'
                    ? product.options[0]
                    : product.options[0].name
                  : labels.variant;

              const selectLabel = formatSelectOptionLabel(labels.selectOption, optionName);

              const variantOptions =
                product.variants.length > 1
                  ? product.variants
                    .map((variant) => {
                      const label =
                        variant.option1 || variant.option2 || variant.option3 || variant.title;
                      return `<option value="${variant.id}">${label}</option>`;
                    })
                    .join('')
                  : '';

              html += `
              <div class="cart-related-product-row" data-index="${index}">
                <div class="cart-related-product-image">
                  <a href="${product.url}">
                    <img src="https:${product.featured_image}" alt="${product.title}" loading="lazy" decoding="async">
                  </a>
                </div>
                <div class="cart-related-product-info">
                  ${product.vendor
                ? `<div class="cart-related-product-vendor">${product.vendor}</div>`
                : ''
              }
                  <a href="${product.url}" class="cart-related-product-title">${product.title}</a>
                  ${firstVariant.sku
                ? `<div class="cart-related-product-sku">${labels.sku}: ${firstVariant.sku}</div>`
                : ''
              }
                  <div class="cart-related-product-price-wrap">
                    <span class="cart-related-product-price">
                      ${formatRelatedMoney(firstVariant.price)}
                    </span>
                    ${firstVariant.compare_at_price
                ? `<span class="cart-related-product-compare">
                            ${formatRelatedMoney(firstVariant.compare_at_price)}
                          </span>`
                : ''
              }
                  </div>
                </div>
                <div class="cart-related-product-actions">
                  <div class="cart-related-product-qty">
                    <button type="button" class="cart-related-product-qty-minus" aria-label="${labels.decrease}">−</button>
                    <input type="number" class="cart-related-product-qty-input" value="${qtyIncrement}" min="${qtyIncrement}" step="${qtyIncrement}" data-qty-increment="${qtyIncrement}" aria-label="${labels.quantity}">
                    <button type="button" class="cart-related-product-qty-plus" aria-label="${labels.increase}">+</button>
                  </div>
                  ${product.variants.length > 1
                ? `<button type="button" class="cart-related-product-add cart-related-product-add--options" data-variant-id="">
                          <span class="cart-related-product-add-text">${labels.options}</span>
                          <div class="loading-overlay__related hidden">
                            <div class="loading-overlay__spinner">
                              <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                                <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                              </svg>
                            </div>
                          </div>
                        </button>`
                : `<button type="button" class="cart-related-product-add" data-variant-id="${firstVariant.id}">
                          <span class="cart-related-product-add-text">${labels.add}</span>
                          <div class="loading-overlay__related hidden">
                            <div class="loading-overlay__spinner">
                              <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                                <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                              </svg>
                            </div>
                          </div>
                        </button>`
              }
                </div>
                ${product.variants.length > 1
                ? `<div class="cart-related-product-variant-dropdown">
                        <div class="cart-related-product-variant-select-wrap">
                          <select class="cart-related-product-variant-select" data-product-index="${index}" aria-label="${selectLabel}">
                            <option value="">${selectLabel}</option>
                            ${variantOptions}
                          </select>
                        </div>
                      </div>`
                : ''
              }
              </div>
            `;
            });

            container.innerHTML = html;

            const params = new URLSearchParams(window.location.search);
            if (params.has('fxtest') && params.get('fxtest') === 'true') {
              const wrapper = document.querySelector('.cart-related-products');
              if (wrapper) wrapper.style.display = 'block';
            }

            bindRelatedProductQtyControls(container);

            // Variant select
            container.querySelectorAll('.cart-related-product-variant-select').forEach((select) => {
              select.onchange = function (event) {
                event.stopPropagation();
                const row = this.closest('.cart-related-product-row');
                if (!row) return;

                const button = row.querySelector('.cart-related-product-add');
                const dropdown = row.querySelector('.cart-related-product-variant-dropdown');
                if (!button) return;

                const variantId = this.value;
                const labelEl = button.querySelector('.cart-related-product-add-text');

                if (variantId) {
                  button.dataset.variantId = variantId;
                  if (labelEl) labelEl.textContent = labels.add;
                  button.classList.remove('cart-related-product-add--options');
                  if (dropdown) dropdown.classList.add('is-open');
                } else {
                  button.dataset.variantId = '';
                  if (labelEl) labelEl.textContent = labels.options;
                  button.classList.add('cart-related-product-add--options');
                  if (dropdown) dropdown.classList.add('is-open');
                }
              };
            });

            // Add to cart (using section rendering API instead of full reload)
            container.querySelectorAll('.cart-related-product-add').forEach((btn) => {
              btn.onclick = function () {
                const variantId = this.dataset.variantId;

                if (!variantId) {
                  const row = this.closest('.cart-related-product-row');
                  const dropdown = row && row.querySelector('.cart-related-product-variant-dropdown');
                  if (dropdown) dropdown.classList.toggle('is-open');
                  return;
                }

                const row = this.closest('.cart-related-product-row');
                const input = row && row.querySelector('.cart-related-product-qty-input');
                const increment = getQtyIncrementFromInput(input);
                const quantity = input
                  ? normalizeQtyToIncrement(input.value, increment)
                  : increment;

                const buttonEl = this;
                const overlay =
                  row && row.querySelector('.loading-overlay__related');

                const setLoading = (isLoading) => {
                  if (buttonEl) {
                    if (isLoading) {
                      if (!buttonEl.dataset.originalLabel) {
                        buttonEl.dataset.originalLabel = buttonEl.innerHTML;
                      }
                      buttonEl.setAttribute('aria-disabled', 'true');
                      buttonEl.classList.add('loading');
                      const labelEl = buttonEl.querySelector('.cart-related-product-add-text');
                      if (labelEl) {
                        labelEl.textContent = '';
                      }
                    } else {
                      buttonEl.classList.remove('loading');
                      buttonEl.removeAttribute('aria-disabled');
                      if (buttonEl.dataset.originalLabel) {
                        buttonEl.innerHTML = buttonEl.dataset.originalLabel;
                      }
                    }
                  }

                  if (overlay) {
                    if (isLoading) {
                      overlay.classList.remove('hidden');
                    } else {
                      overlay.classList.add('hidden');
                    }
                  }
                };

                const cartDrawer =
                  document.querySelector('cart-drawer') ||
                  document.querySelector('cart-notification');

                if (!cartDrawer) {
                  setLoading(true);

                  const fallbackBody = JSON.stringify({
                    items: [{ id: variantId, quantity }],
                  });

                  fetch(`${root}cart/add.js`, {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json',
                    },
                    body: fallbackBody,
                  })
                    .then((res) => res.json())
                    .then((data) => {
                      if (data.status && data.status >= 400) {
                        if (data.description) {
                          // eslint-disable-next-line no-alert
                          alert(data.description);
                        }
                        return;
                      }

                      if (window.routes && window.routes.cart_url) {
                        window.location = window.routes.cart_url;
                      } else {
                        window.location.reload();
                      }
                    })
                    .catch(() => { });

                  return;
                }

                setLoading(true);

                const config = fetchConfig('javascript');

                config.headers['X-Requested-With'] = 'XMLHttpRequest';
                delete config.headers['Content-Type'];

                const formData = new FormData();
                formData.append('id', variantId);
                formData.append('quantity', quantity);

                if (typeof cartDrawer.getSectionsToRender === 'function') {
                  const sections = cartDrawer.getSectionsToRender().map((section) => section.id);
                  formData.append('sections', sections);
                  formData.append('sections_url', window.location.pathname);
                }

                if (typeof cartDrawer.setActiveElement === 'function') {
                  cartDrawer.setActiveElement(document.activeElement);
                }

                config.body = formData;

                fetch(`${routes.cart_add_url}`, config)
                  .then((res) => res.json())
                  .then((data) => {
                    if (data.status) {
                      if (data.description) {
                        // eslint-disable-next-line no-alert
                        alert(data.description);
                      }
                      return;
                    }

                    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                      publish(PUB_SUB_EVENTS.cartUpdate, {
                        source: 'cart-related-products',
                        productVariantId: variantId,
                      });
                    }

                    if (typeof cartDrawer.renderContents === 'function') {
                      cartDrawer.renderContents(data);
                    }
                  })
                  .catch(() => { })
                  .finally(() => {
                    setLoading(false);

                    if (typeof renderRelatedProducts === 'function') {
                      renderRelatedProducts();
                    }
                  });
              };
            });
          });
        });
    });
}

document.addEventListener('DOMContentLoaded', renderRelatedProducts);
